import React from "react";
import { Link } from "react-router-dom";

const NavTop = () => {
  return (
    <div>
      <div className="nav-top">
        <div className="nav-top-main">
          <div className="nav-top-col-1">
            <div className="nav-top-col-1-icon">₹</div>
            <div className="nav-top-col-1-text">
              We do not received extra charges
            </div>
          </div>

          <div className="nav-top-col-2">
            <div className="nav-top-col-2-links">
              <div>Get Upto 15% Off On All Services <span>(Limited Period Offer*)</span></div>
            
            
              {/* <Link to="">About Us</Link>
              <Link to="">Terms & Condition</Link>
              <Link to="">Apply Online</Link> */}
            </div>

              
            <div className="nav-top-col-2-social">
                
                <a to=""><i class="fa-brands fa-youtube"></i></a>
                <a to=""><i class="fa-brands fa-instagram"></i></a>
                <a to=""><i class="fa-brands fa-facebook-f"></i></a>
                <a to=""><i class="fa-brands fa-google"></i></a>
                <a to=""><i class="fa-brands fa-twitter"></i></a>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavTop;
